/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */

import { useEffect, useState } from "react";

const useExpirationTracker = (initialExpirySeconds?: number, onExpired?: () => void) => {
  const [isExpired, setIsExpired] = useState(false);
  const [remainingTime, setRemainingTime] = useState<number>(0);

  useEffect(() => {
    const storedExpiryTimestamp = window.sessionStorage.getItem("yoti_expiry_timestamp");

    let expiryTimestamp: number;

    if (storedExpiryTimestamp) {
      expiryTimestamp = parseInt(storedExpiryTimestamp, 10);
    } else if (initialExpirySeconds) {
      expiryTimestamp = Date.now() + (initialExpirySeconds * 1000);
      window.sessionStorage.setItem("yoti_expiry_timestamp", expiryTimestamp.toString());
    } else {
      expiryTimestamp = 0;
    }

    if (expiryTimestamp) {
      const currentTime = Date.now();

      if (currentTime >= expiryTimestamp) {
        setIsExpired(true);
        onExpired?.();
      } else {
        const initialRemainingSeconds = Math.floor((expiryTimestamp - currentTime) / 1000);
        setRemainingTime(initialRemainingSeconds);
      }

      const intervalId = setInterval(() => {
        const now = Date.now();

        if (now >= expiryTimestamp) {
          setIsExpired(true);
          clearInterval(intervalId);
          onExpired?.();
        } else {
          // Update remaining time
          const updatedRemainingSeconds = Math.floor((expiryTimestamp - now) / 1000);
          setRemainingTime(updatedRemainingSeconds);
        }
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [initialExpirySeconds, onExpired]);

  const setExpiryTime = (expirySeconds: number) => {
    const expiryTimestamp = Date.now() + (expirySeconds * 1000);
    window.sessionStorage.setItem("yoti_expiry_timestamp", expiryTimestamp.toString());

    setIsExpired(false);
    setRemainingTime(expirySeconds);
  };

  const resetExpiredFlag = () => {
    setIsExpired(false);
  };

  return { isExpired, remainingTime, setExpiryTime, resetExpiredFlag };
};

export default useExpirationTracker;
